export default __webpack_public_path__ + "static/Logo 4-6c82d34122595b3fae9ba8d54d047126.png";